<div class="row g-0 d-flex justify-content-center">
    <div class="col-12">
        <ul class="nav nav-tabs justify-content-center">

            <li class="nav-item">
                <a class="nav-link" [ngClass]="{'active': selectedDevice === 'mobile'}" (click)="SelectDevice('mobile')" (keydown.enter)="SelectDevice('mobile')" tabindex="0">
                    <i class="bi bi-phone" style="font-size: 2rem"></i>
                    @if (mobileModified) {
                        <button 
                            class="modified-indicator reset-btn" 
                            (click)="ResetBreakpoint($event, 'mobile')"
                            title="Reset all mobile modifications"
                            type="button"
                        >
                            <i class="bi bi-x"></i>
                        </button>
                    }
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{'active': selectedDevice === 'tablet'}" (click)="SelectDevice('tablet')" (keydown.enter)="SelectDevice('tablet')" tabindex="0">
                    <i class="bi bi-tablet" style="font-size: 2rem"></i>
                    @if (tabletModified) {
                        <button 
                            class="modified-indicator reset-btn" 
                            (click)="ResetBreakpoint($event, 'tablet')"
                            title="Reset all tablet modifications"
                            type="button"
                        >
                            <i class="bi bi-x"></i>
                        </button>
                    }
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{'active': selectedDevice === 'desktop'}" (click)="SelectDevice('desktop')" (keydown.enter)="SelectDevice('desktop')" tabindex="0">
                    <i class="bi bi-laptop" style="font-size: 2rem"></i>
                    @if (desktopModified) {
                        <button 
                            class="modified-indicator reset-btn" 
                            (click)="ResetBreakpoint($event, 'desktop')"
                            title="Reset all desktop modifications"
                            type="button"
                        >
                            <i class="bi bi-x"></i>
                        </button>
                    }
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [ngClass]="{'active': selectedDevice === 'fullscreen'}" (click)="SelectDevice('fullscreen')" (keydown.enter)="SelectDevice('fullscreen')" tabindex="0">
                    <i class="bi bi-fullscreen" style="font-size: 2rem"></i>
                </a>
            </li>
        </ul>
    </div>

    <div class="col-12 g-0 responsive-container" [ngClass]="{
    'fullscreen': selectedDevice === 'fullscreen',
    'desktop': selectedDevice === 'desktop',
    'tablet': selectedDevice === 'tablet',
    'mobile': selectedDevice === 'mobile'
}" >
    <ng-content></ng-content>
    </div>
</div>